import { render, staticRenderFns } from "./geserjadwalkoran.vue?vue&type=template&id=d3028ae6"
import script from "./geserjadwalkoran.vue?vue&type=script&lang=js"
export * from "./geserjadwalkoran.vue?vue&type=script&lang=js"
import style0 from "./geserjadwalkoran.vue?vue&type=style&index=0&id=d3028ae6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports